import React, { useState, useEffect } from "react";
import { apiFetch } from "../../api.js";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";

const RtoMasterGrid = () => {
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [dropdownValue, setDropdownValue] = useState("sp_82_3_1");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);

  useEffect(() => {
    fetchGridData();
  }, []);

  const fetchGridData = async () => {
    try {
      setLoading(true);
      const response = await apiFetch(
        "/api/RtoMaster/Grid"
      );
      const data = await response.json();
      if (data.message === "No Record Found") {
        setGridData([]);
        setFilteredData([]);
      } else {
        setGridData(data);
        setFilteredData(data);
      }
    } catch (err) {
      console.error("❌ Error fetching Rto Master Grid:", err);
      alert("Unable to fetch Rto Master data from backend.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    let what = "";
    let sp_821 = searchValue;
    let sp_822 = fromDate;
    let sp_823 = toDate;

    switch (dropdownValue) {
      case "sp_82_3_1":
        what = "rtodetfilterA";
        break;
      case "sp_82_20_1":
        what = "rtodetfilterB";
        break;
      case "sp_82_5_1":
        what = "rtodetfilterC";
        break;
      case "sp_82_7":
        what = "rtodetfilterD";
        break;
      case "sp_82_8":
        what = "rtodetfilterE";
        break;
      case "sp_82_9":
        what = "rtodetfilterF";
        break;
      case "Active":
        what = "rtodetfilterG";
        break;
      case "Inactive":
        what = "rtodetfilterH";
        break;
      default:
        what = "";
    }
    try {
      setLoading(true);
      const response = await apiFetch(
        `/api/RtoMaster/Filter?what=${encodeURIComponent(what)}&sp_821=${encodeURIComponent(sp_821)}&sp_822=${encodeURIComponent(sp_822)}&sp_823=${encodeURIComponent(sp_823)}`
      );
      const data = await response.json();
      if (data.message === "No Record Found") {
        setGridData([]);
        setFilteredData([]);
      } else {
        setGridData([data]);
        setFilteredData(data);
      }
    } catch (err) {
      console.error("❌ Error fetching filtered data:", err);
      alert("Unable to fetch filtered data.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (id) => {
    try {
      navigate("/RtoMaster", { state: { editId: id } });
    } catch (err) {
      console.error("❌ Edit navigation error:", err);
    }
  };

  const handleView = async (id) => {
    try {
      navigate("/RtoMaster", { state: { ViewId: id } });
    } catch (err) {
      console.error("❌ View navigation error:", err);
    }
  };

  const handleCopy = async (id) => {
    try {
      const response = await apiFetch(
        `/api/RtoMaster/View/${id}`
      );
      const data = await response.json();
      if (!data) {
        alert("Copy failed: no data found");
        return;
      }
      navigate("/RtoMaster", {
        state: { copyData: data },
      });
    } catch (err) {
      console.error("Copy error:", err);
      alert("Unable to copy record.");
    }
  };

  /*---------------Style--------------*/
  const styles = {
    pageContainer: {
      width: "100%",
      minHeight: "100vh",
      backgroundColor: "#f4f6f8",
      display: "flex",
      justifyContent: "center",
      padding: "10px",
    },
    container: {
      width: "100%",
      maxWidth: "1300px",
      padding: "20px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    },
    titleRow: {
      textAlign: "center",
      fontSize: "1.6rem",
      fontWeight: "bold",
      marginBottom: "20px",
    },
    filterRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      justifyContent: "center",
      marginBottom: "20px",
    },
    searchInput: {
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      minWidth: "150px",
      flexGrow: 1,
      maxWidth: "200px",
    },
    select: {
      padding: "8px 10px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      minWidth: "140px",
      flexGrow: 1,
      maxWidth: "200px",
    },
    searchButton: {
      padding: "10px 14px",
      backgroundColor: "#2196F3",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    addButton: {
      padding: "10px 16px",
      backgroundColor: "#3a28a0ff",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    tableWrapper: {
      overflowX: "auto",
      width: "100%",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "900px",
    },
    th: {
      padding: "10px",
      backgroundColor: "#8B1E3F",
      color: "#fff",
      border: "1px solid #ddd",
      whiteSpace: "nowrap",
    },
    td: {
      padding: "8px",
      border: "1px solid #ddd",
      fontSize: "0.85rem",
    },
    actionButton: (bg) => ({
      padding: "6px 10px",
      backgroundColor: bg,
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      marginRight: "5px",
    }),
    pagination: {
      marginTop: "15px",
      display: "flex",
      justifyContent: "center",
      gap: "10px",
    },
    pageBtn: {
      padding: "6px 12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      cursor: "pointer",
    },
  };

  return (
    <Layout>
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          <div style={styles.titleRow}>Rto Master Grid</div>

          {/* FILTER BAR */}
          <div style={styles.filterRow}>
            {/* DROPDOWN */}
            <select
              value={dropdownValue}
              onChange={(e) => setDropdownValue(e.target.value)}
              style={styles.select}
            >
              <option value="sp_82_3_1">STATE</option>
              <option value="sp_82_20_1">VEHICLE COUNT</option>
              <option value="sp_82_5_1">FUEL TYPE</option>
              <option value="sp_82_7">WHEEL TYPE</option>
              <option value="sp_82_8">EFFECTIVE DATE</option>
              <option value="sp_82_9">CLOSE DATE</option>
              <option value="Active">ACTIVE</option>
              <option value="Inactive">INACTIVE</option>
            </select>

            {/* DATE RANGE */}
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={styles.searchInput}
            />

            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={styles.searchInput}
            />

            {/* SEARCH TEXT */}
            <input
              type="text"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              style={styles.searchInput}
            />

            {/* SEARCH BUTTON */}
            <button style={styles.searchButton} onClick={handleSearch}>
              Search
            </button>

            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              style={styles.select}
            >
              {[10, 20, 50, 100].map((s) => (
                <option key={s} value={s}>
                  {s} / page
                </option>
              ))}
            </select>
            <button
              style={styles.addButton}
              onClick={() => navigate("/RtoMaster")}
            >
              Add New
            </button>
          </div>
          {/* GRID TABLE */}
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>STATE</th>
                  <th style={styles.th}>VEHICLE COUNT</th>
                  <th style={styles.th}>FUEL TYPE</th>
                  <th style={styles.th}>WHEEL TYPE</th>
                  <th style={styles.th}>EFFECTIVE FROM</th>
                  <th style={styles.th}>CLOSE DATE</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((row) => (
                    <tr key={row.sp_812}>
                      <td style={styles.td}>{row.sp_82_3_1}</td>
                      <td style={styles.td}>{row.sp_82_20_1}</td>
                      <td style={styles.td}>{row.sp_82_5_1}</td>
                      <td style={styles.td}>{row.sp_82_7}</td>
                      <td style={styles.td}>{row.sp_82_8}</td>
                      <td style={styles.td}>{row.sp_82_9}</td>

                      <td style={styles.td}>
                        <button
                          style={styles.actionButton("#4CAF50")}
                          onClick={() => handleEdit(row.sp_82_2)}
                        >
                          Edit
                        </button>
                        <button
                          style={styles.actionButton("#4CAF50")}
                          onClick={() => handleView(row.sp_82_2)}
                        >
                          View
                        </button>
                        <button
                          style={styles.actionButton("#673AB7")}
                          onClick={() => handleCopy(row.sp_82_2)}
                        >
                          Copy
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} style={styles.td}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* PAGINATION */}
          <div style={styles.pagination}>
            <button
              style={styles.pageBtn}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            <span>
              Page {currentPage} of {totalPages || 1}
            </span>

            <button
              style={styles.pageBtn}
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RtoMasterGrid;
